import React from 'react';
import {
    ClusterNumberFieldEdit,
} from '@domain/dashboard/cluster/campaign-table-cluster-components/cluster-number-field-edit';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

interface MinimumDailyBudgetValueEdit {
    value: number
    row: any
}

export const MinimumDailyBudgetValueEdit = ({
    value,
    row,
}: MinimumDailyBudgetValueEdit) => (
    <ClusterNumberFieldEdit
        row={row}
        value={value}
        key={CLUSTER_FIELDS_FUNCTIONS.minimumDailyBudgetValue.field}
        field={CLUSTER_FIELDS_FUNCTIONS.minimumDailyBudgetValue.field}
        type={METRICS_TYPES.string}
        precision={2}
    />
);
